const drugScreenCompliantResult = (drugCategory: string) => {
  return drugCategory === 'opioids' ? 'Positive' : 'Negative';
};

export default drugScreenCompliantResult;
